import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmModalData {
    title: string;
    message: string;
    confirmLabel: string;
    cancelLabel: string;
    confirmColor?: 'primary' | 'warn' | 'accent';
}

@Component({
    selector: 'myrtls-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ConfirmModalComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmModalData,
    ) {}

    confirm() {
        this.dialogRef.close(true);
    }
}
